module.exports = __webpack_public_path__ + "img/caret-down-gray.svg";